import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { formatCurrency } from "../../../../utils";
import { DIMENSION_GROUPS, useGetDimensionGroup } from "../../../../hooks/useGetDimensionGroup";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var PromoInstallment = function PromoInstallment(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'bnpl' : _ref$type,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 4 : _ref$count,
    price = _ref.price,
    text = _ref.text;
  var dimension = useGetDimensionGroup();
  var isMobile = dimension === DIMENSION_GROUPS.mobile;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    installmentPrice = _useState2[0],
    setInstallmentPrice = _useState2[1];

  // FOR SSR
  useEffect(function () {
    if (price) {
      setInstallmentPrice(formatCurrency(price));
    }
  }, [price]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('price', "price--".concat(type)),
    color: "white",
    size: isMobile ? 'size8-r' : 'size6-m'
  }, /*#__PURE__*/React.createElement("span", null, installmentPrice), /*#__PURE__*/React.createElement("span", null, "\xD7"), /*#__PURE__*/React.createElement("span", null, count)), /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: isMobile ? 'size8-r' : 'size6-r'
  }, text));
};